var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { staticClass: "affiliations-worked", attrs: { xs12: "" } },
    [
      _c(
        "v-layout",
        { attrs: { "fill-height": "", column: "" } },
        [
          _c(
            "div",
            { staticClass: "mb-3" },
            [
              _c(
                "v-layout",
                { staticClass: "pb-3 pt-3 affiliations-worked--title" },
                [
                  _c("div", { staticClass: "subtitle--dashboard pl-3" }, [
                    _vm._v("Afiliaciones trabajadas")
                  ])
                ]
              ),
              _c(
                "v-layout",
                {
                  attrs: {
                    row: "",
                    "justify-space-between": "",
                    "hidden-sm-and-down": ""
                  }
                },
                [
                  _c(
                    "v-flex",
                    { attrs: { md4: "" } },
                    [
                      _c("search-box", {
                        attrs: { placeholder: "BUSCAR POR NOMBRE O CÓDIGO" },
                        on: { search: _vm.search }
                      })
                    ],
                    1
                  ),
                  _c("v-flex"),
                  _vm.$isAdmin() || _vm.$isBoss()
                    ? _c(
                        "div",
                        [
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "offset-y": "",
                                left: "",
                                bottom: "",
                                "close-on-content-click": false,
                                "close-on-click": false
                              },
                              model: {
                                value: _vm.pendingMenuOpen,
                                callback: function($$v) {
                                  _vm.pendingMenuOpen = $$v
                                },
                                expression: "pendingMenuOpen"
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mr-2 v-btn v-btn--light mr-0",
                                  attrs: { slot: "activator" },
                                  slot: "activator"
                                },
                                [_vm._v("Afiliaciones sin CC")]
                              ),
                              _c("BtnWithoutCC", {
                                on: {
                                  close: function($event) {
                                    _vm.pendingMenuOpen = !_vm.pendingMenuOpen
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        bottom: "",
                        "offset-y": "",
                        left: "",
                        "close-on-content-click": false,
                        "close-on-click": false
                      },
                      model: {
                        value: _vm.menu,
                        callback: function($$v) {
                          _vm.menu = $$v
                        },
                        expression: "menu"
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "v-btn v-btn--light mx-0",
                          attrs: { slot: "activator" },
                          on: { click: _vm.setMenuActivator },
                          slot: "activator"
                        },
                        [_vm._v("Filtros")]
                      ),
                      _c("btn-filters", {
                        attrs: { conditional: true, tableName: "Work" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "v-btn v-btn--light mr-0",
                      on: { click: _vm.exportTable }
                    },
                    [_vm._v("Exportar")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "panel-box",
            [
              _c(
                "v-layout",
                { attrs: { "fill-height": "", column: "" } },
                [
                  _c("v-flex", [
                    _c("table", { staticClass: "table mt-3 mb-2" }, [
                      _c("thead", [
                        _c("tr", [
                          _c(
                            "th",
                            { staticStyle: { padding: "15px !important" } },
                            [_c("span", [_vm._v("Fecha de ingreso")])]
                          ),
                          _c("th", { attrs: { width: "150" } }, [
                            _c("span", [_vm._v("Producto seleccionado")])
                          ]),
                          _c("th", { attrs: { width: "150" } }, [
                            _vm._v("RUC")
                          ]),
                          _c("th", [_vm._v("Razón Social")]),
                          _vm.$isSupervisor() || _vm.$isBoss() || _vm.$isAdmin()
                            ? _c("th", [_c("span", [_vm._v("Vendedor")])])
                            : _vm._e(),
                          _c("th", [
                            _c("span", [_vm._v("Correo representante")])
                          ]),
                          _c("th", [
                            _c("span", [_vm._v("Codigo de Comercio")])
                          ]),
                          _c("th", { staticClass: "visual-responsive2" }, [
                            _c("span", [_vm._v("Estado")])
                          ]),
                          _c(
                            "th",
                            {
                              staticClass: "visual-responsive2 hidden-sm-and-up"
                            },
                            [_vm._v("Vendedor")]
                          )
                        ])
                      ]),
                      _vm.fullTable
                        ? _c(
                            "tbody",
                            { staticClass: "notStep linked__tbody-table" },
                            _vm._l(_vm.affiliationsWorked, function(
                              affiliation,
                              index
                            ) {
                              return _c(
                                "tr",
                                {
                                  key: index,
                                  on: {
                                    click: function($event) {
                                      _vm.toDetailAffiliation(affiliation)
                                    }
                                  }
                                },
                                [
                                  _c("td", { staticClass: "table_code" }, [
                                    _vm._v(_vm._s(affiliation.RegisterDate))
                                  ]),
                                  _c("td", { attrs: { width: "150" } }, [
                                    _c("span", [
                                      _vm._v(_vm._s(affiliation.SelectProduct))
                                    ])
                                  ]),
                                  _c("td", { attrs: { width: "150" } }, [
                                    _vm._v(_vm._s(affiliation.RUC))
                                  ]),
                                  _c("td", [
                                    _c("span", [
                                      _vm._v(_vm._s(affiliation.BusinessName))
                                    ])
                                  ]),
                                  _vm.$isSupervisor() ||
                                  _vm.$isBoss() ||
                                  _vm.$isAdmin()
                                    ? _c("td", [
                                        _c("span", [
                                          _vm._v(_vm._s(affiliation.Seller))
                                        ])
                                      ])
                                    : _vm._e(),
                                  _c("td", [
                                    _c("span", [
                                      _vm._v(_vm._s(affiliation.Email))
                                    ])
                                  ]),
                                  _c("td", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.setCodigoComercio(
                                            affiliation.CommerceCodePEN,
                                            affiliation.CommerceCodeUSD
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _c(
                                    "td",
                                    { staticClass: "visual-responsive2" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "hidden-sm-and-down mb-0",
                                          attrs: { width: "150" }
                                        },
                                        [_vm._v(_vm._s(affiliation.Status))]
                                      ),
                                      _c(
                                        "v-layout",
                                        {
                                          staticClass: "hidden-sm-and-up",
                                          attrs: {
                                            "align-center": "",
                                            "justify-space-between": "",
                                            row: "",
                                            "fill-height": ""
                                          }
                                        },
                                        [
                                          _c("v-flex", [
                                            _c("p", { staticClass: "mb-0" }, [
                                              _vm._v(
                                                _vm._s(
                                                  affiliation.SelectProduct
                                                )
                                              )
                                            ]),
                                            _c("p", { staticClass: "mb-0" }, [
                                              _c("strong", [_vm._v("RUC")]),
                                              _vm._v(
                                                " " + _vm._s(affiliation.RUC)
                                              )
                                            ]),
                                            _c("p", { staticClass: "mb-0" }, [
                                              _vm._v(
                                                _vm._s(affiliation.BusinessName)
                                              )
                                            ]),
                                            _c(
                                              "div",
                                              {
                                                class:
                                                  affiliation.Status ===
                                                  "No concretada"
                                                    ? "redText"
                                                    : ""
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(affiliation.Status)
                                                )
                                              ]
                                            )
                                          ]),
                                          _c(
                                            "v-flex",
                                            { staticClass: "box-icon" },
                                            [
                                              _c("v-icon", [
                                                _vm._v("icon-ic-pag-right")
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c("nuxt-link", {
                                        attrs: { to: "affiliation-detail" }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            })
                          )
                        : _c("tbody", [
                            _c("tr", { staticClass: "no__show-data" }, [
                              _c("td", [
                                _vm._v(
                                  "No hay información suficiente para mostrar"
                                )
                              ])
                            ])
                          ]),
                      _c("tfoot", { staticClass: "hidden-sm-and-up" }, [
                        _c("tr", [
                          _c(
                            "td",
                            [
                              _c(
                                "nuxt-link",
                                {
                                  staticClass: "btn-show-all",
                                  attrs: { to: "dashboard/worked" }
                                },
                                [_vm._v("Ver todas")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm.fullTable
                    ? _c("pagination-box", {
                        attrs: { "total-pages": _vm.totalItems },
                        on: { input: _vm.pagination }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cbfe6cc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbfe6cc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/affiliations-worked.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-cbfe6cc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/affiliations-worked.vue
// module chunks = 0 5